import { request } from '@/utils/request'

// get
/* update to v2 */
export const reqDriverInfo = (orderId) =>
  request.get(`v2/instant_order/driver/${orderId}`)

export const reqReserveDriverInfo = (phone) =>
  request.get(`driver/info?account=${phone}`)

export const reqDriverStatus = (phone) => request.get(`status?account=${phone}`)

export const reqPushMsg = (id) =>
  request.get(`pushMessage?id=${id}&message=提醒:${id}單，乘客已取消`)

/* export const reqNonFinishBill = (kw, npp, page) =>
  request.get(`bill/nonFinishBill/?kw=${kw}&npp=${npp}&page=${page}`) */

/* update to v2 */
export const reqTransList = (kw, npp, page, task, picked) =>
  request.get(
    `v2/instant_order?kw=${kw}&per_page=${npp}&current_page=${page}&task=${task}&type=${picked}`,
  )
/* request.get(
    `service/transaction?kw=${kw}&npp=${npp}&page=${page}&task=${task}`,
  ) */

/* add new api request */
export const reqOrderDetail = (orderId) =>
  request.get(`v2/instant_order/${orderId}`)

export const reqNonReply = () =>
  request.get('reservation/list/?npp=0&page=1&task=nonAssign')

/* update to v2 */
export const reqReserveListCount = () =>
  request.get(`v2/reservation_order/count`)

export const reqReserveList = (page) =>
  request.get(`reservation/v2?current_page=${page}&per_page=10`)

export const reqMsgList = (page) =>
  request.get(`message/list/?npp=10&page=${page}&type=1`)

export const reqDefaultMsg = () => request.get('defaultMessage')

export const reqMsg = (nppMsg, pageMsg) =>
  request.get(`serviceComfirmedMessage/?npp=${nppMsg}&page=${pageMsg}`)

export const reqDriverStatusList = (id) =>
  request.get(`status/driverlist/?orderid=${id}`)

// post
export const reqCancelOrder = (cancelInfo) =>
  request.post(`service/callcar/cancel`, cancelInfo)

// put
export const reqDriverAbnormal = (id) =>
  request.put(`updatedriverabnormal?task=update_message_solve&id=${id}`)

export const reqDriverCancel = (orderIdObj) =>
  request.put(`service/driver/cancel`, orderIdObj)

export const reqUpdateAbnormalMsg = (abnormalId) =>
  request.put(
    `updatedriverabnormal/?id=${abnormalId}&task=update_message_status`,
  )

export const reqAbnormalSolve = (abnormalId) =>
  request.put(
    `updatedriverabnormal/?id=${abnormalId}&task=update_message_solve`,
  )

export const reqUpdateReserve = (reservation) =>
  request.put('reservation/updatePassenger', reservation)



// WEBPACK FOOTER //
// ./src/api/hailState-v2/index.js